import { computed } from "vue";

/**
 * The selection in the shape the `value` property and the `input` event carry: an array while
 * `multiple`, the single entry otherwise. Under `return-object` each entry is its resolved item.
 *
 * @param {{ model: import("vue").Ref<any[]>, multiple: import("vue").Ref<boolean>,
 *   returnObject: import("vue").Ref<boolean>, resolvedItem: (value: any) => any }} options
 * @returns {{ selection: import("vue").ComputedRef<any> }}
 */
export function useSelectionValue({ model, multiple, returnObject, resolvedItem }) {
  const selection = computed(() => {
    const entries = returnObject.value ? model.value.map(resolvedItem) : model.value;

    return multiple.value ? entries : entries?.[0];
  });

  return {
    selection,
  };
}
